/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Roleupdated1Inputs */

const en_settings_collaborators_roleupdated1 = /** @type {(inputs: Settings_Collaborators_Roleupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated`)
};

/**
* | output |
* | --- |
* | "Updated" |
*
* @param {Settings_Collaborators_Roleupdated1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_roleupdated1 = /** @type {((inputs?: Settings_Collaborators_Roleupdated1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Roleupdated1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_roleupdated1(inputs)
});
export { settings_collaborators_roleupdated1 as "settings_collaborators_roleUpdated" }